import router from '../router'
import cookie from '../config/cookie'
export default{
  // 储存user_id,token
  SAVEUSER (state, user) {
    state.isLogin = true
    state.userInfo = user
    localStorage.setItem('userInfo', JSON.stringify(user))
    cookie.set('isLogin', true, 5)
  },
  // 登录失效
  LOSELOGIN (state, value) {
    state.isLogin = false
    state.userInfo = {}
    localStorage.removeItem('userInfo')
    cookie.del('isLogin')
    console.log('执行清除')
    router.push({path: '/login'})
  },
  SETPAGEPYOFFSET (state, val) {
    state.pageYOffset = val
  },
  SETPLATFORM (state, val) {
    state.platform = val
  }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js